import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import SearchService from "../services/SearchService";

const useSearchService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new SearchService(client);
  }, [client]);

  return service;
};

export default useSearchService;
